// extracted by mini-css-extract-plugin
export var buttonWithIcon = "DefaultButton-module--buttonWithIcon--XmpaM";
export var button = "DefaultButton-module--button---O+zW";
export var text = "DefaultButton-module--text--ANGM7";
export var icon = "DefaultButton-module--icon--dMQMQ";